const _excluded = ["onChange", "onFocus", "onBlur", "onValueChange", "value", "error", "size", "readOnly", "disabled", "sizeInput", "allowDecimals", "decimalScale", "dataTestId", "placeholder", "className", "max", "min"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import { FormSize } from "../../../../view-model";
import { useFormCommonProps } from "../../../context/form-common";
import { NumericFormat } from 'react-number-format';
import { isValidOnBlur, numberValidation } from "../input-number-utils";
import '@isyc-react/design/main';
export const InputNumber = /*#__PURE__*/React.forwardRef((props, ref) => {
  const _useFormCommonProps = useFormCommonProps(props),
    {
      onChange,
      onFocus,
      onBlur,
      onValueChange,
      value,
      error,
      size,
      readOnly,
      disabled,
      sizeInput,
      allowDecimals = true,
      decimalScale,
      dataTestId,
      placeholder,
      className = 'form-control',
      max,
      min
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  const [focused, setFocused] = React.useState(false);
  const [validationError, setValidationError] = React.useState(error || false);
  React.useEffect(() => {
    setValidationError(!isValidOnBlur(value, min, max, focused));
  }, [focused, value, min, max]);
  return /*#__PURE__*/React.createElement(NumericFormat, _extends({
    className: clsx({
      'form-control-sm': size === FormSize.SM,
      'form-control-lg': size === FormSize.LG,
      'is-invalid': error || validationError,
      'form-control-plaintext': readOnly,
      [className]: !readOnly
    }),
    onValueChange: (v, s) => {
      var _v$floatValue;
      onChange && onChange((_v$floatValue = v.floatValue) !== null && _v$floatValue !== void 0 ? _v$floatValue : null);
      // onValueChange && onValueChange(v, s)
    },

    "data-test-id": dataTestId,
    onFocus: () => {
      onFocus && onFocus();
      setFocused(true);
    },
    onBlur: () => {
      onBlur && onBlur();
      setFocused(false);
    },
    value: validationError ? '' : value,
    size: sizeInput,
    readOnly: readOnly,
    disabled: disabled,
    placeholder: placeholder,
    decimalScale: allowDecimals ? decimalScale : 0,
    isAllowed: v => numberValidation(v.floatValue, max, min),
    getInputRef: ref
  }, rest));
});